<template>
  <div
    @click="fetchLiveLectureUrl(event.data.live_lecture_id)"
    class="px-0 pb-3 text-left col-12"
  >
    <div
      v-loading="isBusy"
      class="card card-body"
      :style="{
      backgroundColor: event.type == 'Lecture' ? '#d7d7f3' : '#FFD6C4',
    }"
      style="cursor: pointer"
    >
      <i
        v-if="event.data.class_status && event.data.attendance_report.is_attended"
        class="el-icon-check color-green"
        style="font-size: 20px; position: absolute; right: 10px; top: 10px"
      ></i>
      <i
        v-else-if="event.data.class_status && !event.data.attendance_report.is_attended"
        class="el-icon-close color-red"
        style="font-size: 20px; position: absolute; right: 10px; top: 10px"
      ></i>
      <div
        class=""
        style="font-weight: 500; color: rgba(0, 0, 0, 0.5); font-size: 0.8em"
      >
        {{ event.type }}
      </div>
      <div
        class=""
        style="font-weight: 600; color: var(--el-app-primary); font-size: 0.9em"
      >
        {{ event.data.title == "N/A" ? "Topic N/A" : event.data.title }}
      </div>
      <div
        class="mt-2"
        style="font-weight: 600; color: #000; font-size: 0.8em"
      >
        {{ formattedDate(event.data.date) }}
      </div>
      <div style="font-weight: 600; color: #000; font-size: 0.8em">
        {{ `${event.data.start_time} - ${event.data.end_time}` }}
      </div>
      <div
        class=""
        style="font-weight: 500; color: rgba(0, 0, 0, 0.4); font-size: 0.8em"
      >
        By {{ event.data.lecturer.first_name }}
        {{ event.data.lecturer.last_name }}
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from "date-fns";
export default {
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    formattedDate() {
      return (dateString) => format(parseISO(dateString), "do MMMM yyyy");
    },
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async fetchLiveLectureUrl(lectureId) {
      if (this.isBusy) return;
      let request = await this.httpRequest({
        method: "GET",
        url: `live-lecture/get-student-class-url/by-live-lecture-id/${lectureId}`,
        loadingPropertyName: "isBusy",
        showSuccessMessage: false,
      });

      if (!request) return;

      if (
        request.success &&
        request.message == "LIVE CLASS URL RETRIEVED"
      ) {
        // Store the access token in the session storage
        sessionStorage.setItem("liveClassAccessToken", request.token);
        sessionStorage.setItem("liveClassRedirectUrl", this.$route.path);

        return this.$router.push("/ongoing-lecture");
        // window.location.href = request.lecture_link;
      } //Otherwise if its a google meet url
      else if (request.message === "Google Meet URL retrieved") {
        window.location.href = request.google_meet_url;
      }
    },
  },
};
</script>

<style scoped>
.color-red {
  color: red !important;
}

.color-green {
  color: rgb(7, 206, 7) !important;
}
</style>